import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsByClientAsync(clientId) {
        return (await Vue.http.get(`/api/komplexbridge/settings/byclient/${clientId}`)).data;
    },
    async saveAsync(clientId, settings) {
        await Vue.http.post(`/api/komplexbridge/settings/byclient/${clientId}`, settings);
        noty.success("Settings saved successfully");
    },
    async syncGamesAsync(clientId, settings) {
        await Vue.http.post(`/api/komplexbridge/settings/byclient/${clientId}/games/sync`, settings);
        noty.success("Games sync completed");
    },
    async clearGamesCacheAsync(clientId, settings) {
        await Vue.http.post(`/api/komplexbridge/settings/byclient/${clientId}/games/clearcache`, settings);
        noty.success("Games cache cleared");
    },
    async getAvailableGamesAsync(clientId, settings) {
        return (await Vue.http.post(`/api/komplexbridge/settings/byclient/${clientId}/games/available`, settings)).data;
    }
};


// WEBPACK FOOTER //
// ./src/services/komplexbridge.service.js